
import React, { Component } from 'react';
import CdnImage from '../../../../components/cdnImage/cdnImage';

const configurationManager = require('../../../../utils/config/configurationManager.js');
const cdnAppCloudName = configurationManager.getConfig().cdnAppCloudName;

class SelectButtonGroupView extends Component 
{
    render()
    {
        return (
            <div className='d-flex flex-column'>

                <div className='mb-2 d-flex justify-content-between align-items-center border-bottom'>
                    <div>{this.props.label}</div>
                    <div className='text-muted text-wrap' style={{ fontSize: "0.75em" }}>
                        {this.props.valueList.join(", ")}
                    </div>
                </div>

                <div className='d-flex flex-wrap gap-2'>
                    {
                        this.props.options.map(option => this.getButtonContents(option.imageUrl, option.value))
                    }
                </div>
            </div>
        );
    }

    getButtonContents(imageUrl, value) 
    {
        let contents;

        const isSelected = this.props.valueList.includes(value);

        contents =
            <div className={`font-weight-bold ${isSelected ? 'text-primary' : 'text-muted'}`}>
                {value}
            </div>;

        if (imageUrl)
        {
            contents =
                <div className='mr-3 d-flex flex-column align-items-center'>
                    <CdnImage publicId={imageUrl} cloudName={cdnAppCloudName} width={50} height={50} radius="0" grayScale={!isSelected} />
                    <div className={`mt-1 font-weight-bold ${isSelected ? 'text-primary' : 'text-muted'}`} style={{ fontSize: "0.7em" }}>{value}</div>
                </div>
        }

        return (
            <div
                style={{ minWidth: "250", height: "200" }}
                className={`p-3 mr-2 d-flex justify-content-center align-items-center rounded ${isSelected ? 'border border-primary' : 'border'}`}
                onClick={() => this.props.onSelect(value)}>
                {contents}
            </div>
        );
    }
}

export default SelectButtonGroupView;